import './index.css';

const WebGuide: React.FC<any> = (props) => {
    const { data } = props
    return (
        <div className="wrapWebGuide"></div>)
}



export default WebGuide;
